export const CardOnFileValidationMessages = {
    creditCardExpired:
        'The selected credit card has expired. Please select a different card or update the expiration date.',
} as const;
